<template lang="pug">
  
	div

		div.col-md-12.float-box-title-extras

			hr

			form
				div.input-group.input-group-sm.invisible-addon

					input.form-control.form-control-sm#camadas-filter(v-model="filtro",
							type="text", placeholder="Procure por uma camada...")

					div.input-group-addon(@click="setFocusFiltro()", v-if="!filtro")
						i.mdi.mdi-magnify

					div.input-group-addon(@click="limparFiltro()", v-if="filtro", title="Limpar")
						i.mdi.mdi-close.action-icon

		//- Abas de navegação
		nav.nav.nav-tabs.float-box-nav

			a.col-md-6.nav-link.text-center(href="#",
					:class="{ active: tela === ESTRUTURA }",
					@click="setTela(ESTRUTURA)") Todas

			a.col-md-6.nav-link.text-center(href="#",
					:class="{ active: tela === ATIVAS }",
					@click="setTela(ATIVAS)") Ativas

		div.float-box-content.content-camadas
			
			//- Arvore contendo todas as camadas

			div.col-md-12(v-show="tela === ESTRUTURA")

				.row(v-if="estruturaCamadas")
					
					.col-12.float-box-content-menu.d-flex.flex-row-reverse
					
						div.action-link(@click="collapseAll()")
							span.mdi.mdi-arrow-collapse  
							|  Contrair
					
						div.action-link(@click="expandAll()")
							span.mdi.mdi-arrow-expand  
							|  Expandir

				camadas-tree(:model="estruturaCamadas", 
						v-if="estruturaCamadas",
						v-show="!filtro",
						ref="camadasTree")

				camadas-tree(:model="camadasFiltradas", 
						v-if="estruturaCamadas",
						v-show="filtro")

			empty-result.full-height(message="Nenhuma camada encontrada.", 
					v-show="tela === ESTRUTURA && filtro && !(camadasFiltradas \
						&& camadasFiltradas.camadas && camadasFiltradas.camadas.length)")

			//- Listagem de camadas ativas
			
			div.camadas-ativas(v-show="tela === ATIVAS")

				div.float-box-section-title.col-md-12(v-if="possuiCamadasUsuario")
					label Minhas Camadas
					hr

				//- Camadas do usuário

				draggable(:list="camadasAtivas", 
						:options="{draggable:'.camada-ativa-wrapper', handle: '.col-camada-drag-icon'}",
						@change="onCamadaMoved",
						v-if="possuiCamadasUsuario")

					div.camada-ativa-wrapper(v-for="c in camadasAtivas", v-if="c.camadaUsuario")

						camada-ativa(:camada="c", @remove="removerCamada(c)")

				
				//- Camadas do sistema
				
				div.float-box-section-title.col-md-12(v-if="possuiCamadasUsuario")
					label Camadas SIG
					hr

				draggable(:list="camadasAtivas", 
						:options="{draggable:'.camada-ativa-wrapper', handle: '.col-camada-drag-icon'}",
						@change="onCamadaMoved")

					div.camada-ativa-wrapper(v-for="c in camadasAtivas", v-if="!c.camadaUsuario")

						camada-ativa(:camada="c", @remove="removerCamada(c)")
	
			empty-result.full-height(:message="filtro ? 'Nenhuma camada encontrada.' : 'Nenhuma camada ativa.'", 
					v-show="tela === ATIVAS && !(camadasAtivas && camadasAtivas.length)")

</template>

<script>

import CamadasTree from './CamadasTree';
import CamadaAtiva from './CamadaAtiva';
import IconeLegenda from './IconeLegenda';
import { mapState, mapMutations } from 'vuex';
import stringUtils from '@/utils/stringUtils';
import EmptyResult from '@/components/utils/EmptyResult';
import Draggable from 'vuedraggable';

export default {
	name: 'Camadas',

	components: { CamadasTree, IconeLegenda, EmptyResult, Draggable, CamadaAtiva },

	componentOptions: {
		
		title: 'Camadas',

		actions: [
			[
				{
					name: 'Camadas',
					iconClass: 'mdi mdi-layers',
					showView: true
				}
			]
		]
	},

	data () {
		return {
			ESTRUTURA: 0,
			ATIVAS: 1,
			tela: 0,
			filtro: ''
		};
	},

	methods: {
		setTela (tela) {
			this.tela = tela;
		},

		setFocusFiltro () {
			$('#camadas-filter').focus();
		},

		limparFiltro () {
			this.filtro = '';
		},

		removerCamada (camada) {

			this.desativarCamada(camada);
		},

		filtrarCamadas (camadas, filtro) {

			var filtroTrim = filtro && filtro.trim();

			if (!filtroTrim) {

				this.filtro = filtroTrim;
				return null;
			}

			var filtroLatinized = stringUtils.latinize(filtroTrim).toLowerCase();

			camadas = _.filter(camadas, (c) => {

				return stringUtils.latinize(c.nome)
					.toLowerCase()
					.indexOf(filtroLatinized) >= 0;
			});

			return camadas;
		},

		onCamadaMoved (evt) {
			
			var newIndex = this.camadasAtivas.length - evt.moved.newIndex - 1;
			this.moverCamadaAtiva({ camada: evt.moved.element, index: newIndex });
		},

		expandAll () {
			this.$refs.camadasTree.expandAll();
		},

		collapseAll () {
			this.$refs.camadasTree.collapseAll();
		},

		...mapMutations([
			'ativarCamada',
			'desativarCamada',
			'moverCamadaAtiva'
		])
	},

	computed: {

		camadasAtivas () {
			var camadas = this.$store.state.camadasAtivas &&
				this.$store.state.camadasAtivas.slice().reverse();

			if (!camadas) return camadas;

			if (this.filtro && this.filtro.trim()) {

				return this.filtrarCamadas(camadas, this.filtro);

			} else {

				return camadas;
			}
		},

		possuiCamadasUsuario () {
			var camadas = this.$store.state.camadasAtivas;

			if (camadas) {

				for (let c of camadas) {
					if (c.camadaUsuario) return true;
				}
			}

			return false;
		},

		camadasFiltradas () {
			
			var camadas = this.filtrarCamadas(this.$store.state.camadasOrdenadas, this.filtro);

			return camadas ? { camadas: camadas } : {};
		},

		...mapState([
			'estruturaCamadas'
		])
	},

	watch: {
		camadasAtivas () {

			if (this.$refs.camadasTree) {
				this.$refs.camadasTree.refresh();
			}
		}
	}
};

</script>

<style lang="scss" scoped>

@import "../../styles/variaveis";
@import "../../styles/mixins";

.float-box-content.content-camadas {
	top: $float-box-content-top + 88px;
}

// Estilos utilizados para o drag and drop
.camada-ativa-wrapper {
	padding: 3px 0;
}

.camadas-ativas {
	padding-top: 10px;
}

</style>



// WEBPACK FOOTER //
// Camadas.vue?ff5a7956